import { TOGGLE_REFRESH_TIMER } from './types/MrdMonitoringActionTypes';

export function toggleRefreshTimerActionCreator(action) {
  return {
    type: TOGGLE_REFRESH_TIMER,
    payload: action,
  };
}
